export default __webpack_public_path__ + "static/profile-two-mobile-7bcc318582361495f0d9943de813945b.jpg";